<template>
  <dummy-scout-form
    :is-modified="value !== 1"
    label="行動ターゲティング"
  >
    <div class="boss-targeting-selector">
      <div class="pega-slider padding-bottom-1 padding-top-1">
        <vue-slider
          v-model="label"
          direction="btt"
          :adsorb="true"
          :data="options.map(option => option.label).reverse()"
          :marks="true"
          tooltip="none"
          :height="150"
        />
      </div>
    </div>
  </dummy-scout-form>
</template>

<script>
import DummyScoutForm from '@/components/atoms/DummyScoutForm'
import * as definition from '@/lib/labelValueMappings'
import VueSlider from 'vue-slider-component'
import _ from 'lodash'

export default {
  components: {
    DummyScoutForm,
    VueSlider
  },
  data () {
    return {
      value: 1,
      options: definition.behaviors,
      label: _.find(definition.behaviors, behavior => _.isEqual(1, behavior.value)).label
    }
  },
  watch: {
    label (val) {
      this.$set(this, 'value', _.find(definition.behaviors, behavior => _.isEqual(val, behavior.label)).value)
    }
  }
}
</script>
